<template>
  <v-app>
    <div id="app">
      <router-view />
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      //VARIABLES
    };
  },
  mounted() {
    this.startVersionCheck();
  },
  methods: {
    async startVersionCheck() {
      const CURRENT_VERSION = (await this.getVersion()) || null;

      setInterval(async () => {
        const latestVersion = await this.getVersion();

        if (latestVersion && latestVersion !== CURRENT_VERSION) {
          console.log("Nueva versión detectada. Recargando...");
          window.location.reload(true); // Recarga dura
        }
      }, 60000); // cada 60 segundos
    },

    async getVersion() {
      try {
        const res = await fetch(`/version.json?ts=${Date.now()}`);
        const data = await res.json();
        return data.version;
      } catch (e) {
        console.warn("No se pudo obtener la versión:", e);
        return null;
      }
    }
  }
};
</script>

<style>
@font-face {
  font-family: "montserrat-bold";
  src: url("../src/assets/fonts/Montserrat-Bold.ttf") format("opentype");
}
@font-face {
  font-family: "montserrat-light";
  src: url("../src/assets/fonts/Montserrat-Light.ttf") format("opentype");
}
@font-face {
  font-family: "montserrat-medium";
  src: url("../src/assets/fonts/Montserrat-Medium.ttf") format("opentype");
}
@font-face {
  font-family: "montserrat-regular";
  src: url("../src/assets/fonts/Montserrat-Regular.ttf") format("opentype");
}
@font-face {
  font-family: "montserrat-semibold";
  src: url("../src/assets/fonts/Montserrat-SemiBold.ttf") format("opentype");
}

/* global styles */
html,
body {
  margin: 0;
  padding: 0;
  font-family: "monserrat-regular", sans-serif;
  position: relative;
}

.v-application {
  font-family: "monserrat-regular", sans-serif;
}

.v-data-table__wrapper {
  border-radius: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.75);
  background-color: #f9fafd;
}

.v-data-table {
  background-color: #f9fafd !important;
}

.header__title {
  font-family: "montserrat-bold" !important;
  text-wrap: nowrap; 
  text-align: center !important; 
  background-color: white; 
  padding: 5px 15px !important;
  color: #868DA6 !important; 
  font-size: 12px !important;
  border: 2px solid rgba(0, 0, 0, 0.12) !important; 
}

.header__title.left {
  border-right: none !important;
  border-top-left-radius: 20px; 
  border-bottom-left-radius: 20px;
}

.header__title.center {
  border-right: none !important;
  border-left: none !important; 
}

.header__title.right {
  border-left: none !important; 
  border-top-right-radius: 20px; 
  border-bottom-right-radius: 20px;
}

.table__item {
  text-wrap: nowrap;
  font-family: 'montserrat-bold'; 
  text-align: center;
  border-bottom: thin solid rgba(0,0,0,.12) !important;
}

.table__item__mobile {
  text-wrap: nowrap; 
  font-family: 'montserrat-bold';
  text-align: center; 
  display: flex; 
  justify-content: space-between; 
  align-items: center;
  border-bottom: none !important;
}

</style>
